// src/components/Dashboard_ADM/ui/theme.ts
// Tokens visuais do "Hub" admin — glassmorphism sobre a paleta gold/cosmos que já
// existe em tailwind.config.js (usada hoje só no site público e no ModalPagamento).
// Objetivo: menos ícone grande e colorido, mais painel translúcido + espaço em branco.

export const glass = {
  /** Card padrão — fundo translúcido com blur, borda quase invisível. */
  card: 'bg-white/70 backdrop-blur-xl border border-white/60 shadow-[0_8px_30px_-12px_rgba(10,14,39,0.15)] rounded-3xl',
  cardHover: 'hover:bg-white/85 hover:shadow-[0_16px_40px_-14px_rgba(10,14,39,0.22)] transition-all duration-300',
  /** Pílula pequena (toggle, badge) — mesmo vidro, menos espessura. */
  pill: 'bg-white/60 backdrop-blur-md border border-white/60 rounded-2xl',
  /** Painel escuro (cosmos) para destacar algo importante sem apelar pra cor viva. */
  dark: 'bg-cosmos-900/85 backdrop-blur-xl border border-white/10 text-white rounded-3xl',
};

export const text = {
  label: 'text-[11px] font-semibold text-cosmos-500/70 uppercase tracking-wider',
  value: 'text-3xl font-semibold text-cosmos-900 tracking-tight',
  subtle: 'text-xs text-cosmos-500/70',
  heading: 'text-xl font-semibold text-cosmos-900 tracking-tight',
};
